import app from 'flarum/common/app';
app.initializers.add('rob2dev-sort-changer-common', () => {
  console.log('[rob2dev/sort-changer] Hello, forum and admin!');
});